import { css } from '@emotion/core';

/** Thin themed scrollbar (WebKit + Firefox). Interpolate inside a styled
 * template — `${themedScrollbar}` — at the nesting level whose scrollbar
 * should be styled. */
const themedScrollbar = (props) => css`
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${props.theme.colors.scrollbarThumb};
    border-radius: 3px;
  }

  scrollbar-width: thin;
  scrollbar-color: ${props.theme.colors.scrollbarThumb} transparent;
`;

export default themedScrollbar;
